import { BaseAPI } from "../Common";


export interface ICreateProduct {
    name:string,
    activeIngredients:string[],
    activeIngredientAliases: string,
    countries: string[],
    dosageForm: string,
    routeOfAdministration: string,
    strength: number,
    unitOfMeasurement: string,
    sponsor: string,
    status?:number
}

export interface IUpdateProduct{
    name?:string,
    activeIngredients?:string[],
    activeIngredientAliases?: string,
    countries?: string[],
    dosageForm?: string,
    routeOfAdministration?: string,
    strength?: number,
    unitOfMeasurement?: string,
    status?:number
}


class Product extends BaseAPI {
  create(payload: ICreateProduct): Promise<any> {
    return this.makeRequest(`create`, "post", payload);
  }

  update(productId: string, payload: IUpdateProduct): Promise<any> {
    return this.makeRequest(`update/${productId}`, "patch", payload);
  }

  getAll(name: string): Promise<any> {
    return this.makeRequest(`getMany`, "post", { name });
  }

  getProduct(id: string): Promise<any> {
    return this.makeRequest(`search/${id}`, "get");
  }

  getAllProducts(): Promise<any> {
    return this.makeRequest(`products/by-tenant`, "get");
  }
}

export const product = new Product("product");